export default "https://cdn-static.gokick.com/assets/1efca0ef19d403b8805a53d90e225e0b5d561c25/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";